import React from 'react';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import openGenericModalV13 from 'shared-utils/src/leads/openGenericModalV13';

import Icon from '@components/common/Icon';
import { useCtxGlobal } from '@client/app/Container';
import { getHumanFiltersV13, getPtypesPlurals } from '@helpers/search/Search';
import { getPreviewFromFilters } from '@filters/helpers';

import { createFeedbackModal, createGenericModalV13 } from '../../../modals/factories';

const RizBanner = () => {
  const {
    openModal,
    closeModal,
    updateUserFormData,
    model,
    filtersProps: {
      device,
      mainLocation,
      additionalLocations,
    },
    user,
  } = useCtxGlobal();

  const queryFilters = (model && model.queryFilters) || {};

  const open = () => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'ShowContactAgenciesFormSRP',
    });

    const closeModalAction = (payload) => closeModal(payload.close);

    const leadConf = {
      device,
      mainLocation,
      additionalLocations,
      queryFilters,
      getHumanFiltersV13,
      getPtypesPlurals,
      getPreviewFromFilters,
      user,
    };

    openGenericModalV13({
      openModalAction: openModal,
      closeModalAction,
      createGenericModalV13,
      createFeedbackModal,
      setUserFormDataAction: updateUserFormData,
      leadConf,
    });
  };

  return (
    <button
      type="button"
      aria-label="Contatta le agenzie in zona"
      className="b--0 c-bg--w tp-s--s tp-w--s tp-a--l c-txt--f2 is-clickable is-rel"
      onClick={open}
    >
      Hai bisogno di aiuto per la ricerca?
      <span className="tp-w--m c-txt--secondary tp--u">Chiedi alle agenzie</span>
      <Icon className="icon-riz" name="riz" width="24px" height="21px" aria-hidden="true" />
    </button>
  );
};

export default RizBanner;
